import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Text,
  VStack,
  HStack,
  Link,
  Input,
  Button,
  Divider,
  useColorMode,
  useColorModeValue,
  Icon,
  useToast,
  Flex,
  Heading,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import {
  FiZap,
  FiCheck,
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiHeart,
  FiCpu,
} from "react-icons/fi";

const Footer: React.FC = () => {
  const { colorMode } = useColorMode();
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.400");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const hoverBg = useColorModeValue("gray.50", "gray.700");
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const toast = useToast();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setEmail("");
      toast({
        title: "Subscribed successfully!",
        description: "Thank you for subscribing to our newsletter.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }, 1000);
  };

  return (
    <Box as="footer" bg={bgColor} color={textColor} py={12}>
      <Container maxW="1400px">
        <Grid templateColumns={["1fr", "1fr 1fr", "1fr 1fr 1fr 1fr"]} gap={8}>
          {/* Brand Section */}
          <VStack align="start" spacing={4}>
            <HStack>
              <Icon as={FiCpu} w={8} h={8} color="green.600" />
              <Text fontSize="2xl" fontWeight="bold" color="gray.700">
                TechParts Hub
              </Text>
            </HStack>
            <Text>
              Your one-stop shop for high-quality computer components. We offer a wide range of processors, graphics cards, storage solutions, and more from trusted brands.
            </Text>
          </VStack>

          {/* Quick Links */}
          <VStack align="start" spacing={4}>
            <Heading size="md">Quick Links</Heading>
            <Link as={RouterLink} to="/about">
              About Us
            </Link>
            <Link as={RouterLink} to="/contact">
              Contact
            </Link>
            <Link as={RouterLink} to="/sale">
              Special Deals
            </Link>
          </VStack>

          {/* Categories */}
          <VStack align="start" spacing={4}>
            <Heading size="md">Categories</Heading>
            <VStack align="start" spacing={2}>
              <Link as={RouterLink} to="/category/processors">
                Processors
              </Link>
              <Link as={RouterLink} to="/category/graphics-cards">
                Graphics Cards
              </Link>
              <Link as={RouterLink} to="/category/storage">
                Storage Solutions
              </Link>
              <Link as={RouterLink} to="/category/motherboards">
                Motherboards
              </Link>
              <Link as={RouterLink} to="/category/peripherals">
                Peripherals
              </Link>
              <Link as={RouterLink} to="/category/cooling">
                Cooling Solutions
              </Link>
            </VStack>
          </VStack>

          {/* Support */}
          <VStack align="start" spacing={4}>
            <Heading size="md">Support</Heading>
            <Text fontSize="sm" color="gray.600">
              Get technical support and stay updated with our latest products and deals.
            </Text>
            <form onSubmit={handleSubmit}>
              <InputGroup size="sm">
                <Input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  bg={useColorModeValue("white", "gray.700")}
                  borderColor={borderColor}
                  _hover={{ borderColor: "green.400" }}
                  _focus={{ borderColor: "green.400" }}
                />
                <InputRightElement width="4.5rem">
                  <Button
                    h="1.75rem"
                    size="sm"
                    type="submit"
                    isLoading={isSubmitting}
                    colorScheme="green"
                    variant="ghost"
                  >
                    Subscribe
                  </Button>
                </InputRightElement>
              </InputGroup>
            </form>
            <VStack align="start" spacing={2}>
              <HStack spacing={2}>
                <Icon as={FiZap} color="green.500" />
                <Text fontSize="sm">24/7 Technical Support</Text>
              </HStack>
              <HStack spacing={2}>
                <Icon as={FiCheck} color="green.500" />
                <Text fontSize="sm">Warranty on All Products</Text>
              </HStack>
              <HStack spacing={2}>
                <Icon as={FiCheck} color="green.500" />
                <Text fontSize="sm">Secure Payment Options</Text>
              </HStack>
            </VStack>
          </VStack>
        </Grid>

        <Divider my={8} borderColor={borderColor} />

        <Flex
          direction={["column", "row"]}
          justify="space-between"
          align="center"
          gap={4}
        >
          <Text>
            Copyright © 2025 | Powered by NAFEES ALI TRADERS (SMC-PRIVATE) LIMITED
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
